export default __webpack_public_path__ + "static/media/img-s4-video-right.651c981a.png";